/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
} from "reactstrap";

// core components

function SectionProgress() {
  const [activeTab, setActiveTab] = React.useState("1");
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  return (
    <>
      <div className="section section-dark section-dark-theme gradient-background-claro">
        <Container>
          <div className="title gradient-title">
            <h2 align='center' style={{ marginBottom: '0px', marginTop: '0px', paddingBottom: '30px', paddingTop: '30px' }} >Requirements</h2>
          </div>
          <div className="nav-tabs-navigation">
            <div className="nav-tabs-wrapper">
              <Nav id="tabs" role="tablist" tabs>
                <NavItem style={{ cursor: 'pointer' }}>
                  <NavLink
                    className={activeTab === "1" ? "active" : ""}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    Minimum
                      </NavLink>
                </NavItem>
                <NavItem style={{ cursor: 'pointer' }} >
                  <NavLink
                    className={activeTab === "2" ? "active" : ""}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    Recommended
                      </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
          <TabContent activeTab={activeTab} className="text-center">
            <TabPane tabId="1">
              <Row>
                <Col sm="12" md="2" />
                <Col style={{ textAlign: 'left' }} sm="12" md="6">
                  <div style={{ marginBottom: '7px' }}>
                    <h3 className="section-requirements" > Need </h3>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> SO: </p><p style={{ display: 'inline' }}> Windows 7 / Windows 8.1 / Windows 10 </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> Processor: </p><p style={{ display: 'inline' }}> 1.9GHz </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> Memory: </p><p style={{ display: 'inline' }}> 4GB RAM </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }} > Graphics: </p><p style={{ display: 'inline' }}> Intel(R) UHD Graphics 620 </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> Storage: </p><p style={{ display: 'inline' }}> 2 GB available space in HDD (5400rpm) </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> Screen resolution: </p><p style={{ display: 'inline' }}> 1366x768px </p>
                  </div>
                  <br />
                </Col>
                <Col style={{ textAlign: 'left' }} sm="12" md="2">
                  <div style={{ marginBottom: '7px' }}>
                    <h3 className="section-requirements" > Can </h3>
                  </div>
                  <FormGroup check disabled>
                    <Label check>
                      <Input defaultChecked defaultValue="" disabled type="checkbox" />
                            FullScreen <span className="form-check-sign" />
                    </Label>
                  </FormGroup>
                  <FormGroup check disabled>
                    <Label check>
                      <Input defaultValue="" disabled type="checkbox" />
                            100% stable <span className="form-check-sign" />
                    </Label>
                  </FormGroup>
                  <FormGroup check disabled>
                    <Label check>
                      <Input defaultValue="" disabled type="checkbox" />
                            1 vs 2 <span className="form-check-sign" />
                    </Label>
                  </FormGroup>
                  <FormGroup check disabled>
                    <Label check>
                      <Input defaultValue="" disabled type="checkbox" />
                            2 vs 2 <span className="form-check-sign" />
                    </Label>
                  </FormGroup>
                  <br />
                </Col>
                <Col sm="12" md="2" />
              </Row>
              <p className="text-warning">
                In Arcade mode the game may close with a BG Error message. It is recommended to close resource-intensive applications.
              </p>
            </TabPane>
            <TabPane tabId="2">
              <Row>
                <Col sm="12" md="2" />
                <Col style={{ textAlign: 'left' }} sm="12" md="6">
                  <div style={{ marginBottom: '7px' }}>
                    <h3 className="section-requirements" > Need </h3>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> SO: </p><p style={{ display: 'inline' }}> Windows 7 / Windows 8.1 / Windows 10 </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> Processor: </p><p style={{ display: 'inline' }}> 2.4GHz </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> Memory: </p><p style={{ display: 'inline' }}> 8GB RAM </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }} > Graphics: </p><p style={{ display: 'inline' }}> 2GB Dedicated Card </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> Storage: </p><p style={{ display: 'inline' }}> 2 GB available space in HDD (7200rpm) </p>
                  </div>
                  <div style={{ marginBottom: '7px' }}>
                    <p className="section-requirements" style={{ display: 'inline' }}> Screen resolution: </p><p style={{ display: 'inline' }}> 1920x1080px </p>
                  </div>
                  <br />
                </Col>
                <Col style={{ textAlign: 'left' }} sm="12" md="2">
                  <div style={{ marginBottom: '7px' }}>
                    <h3 className="section-requirements" > Can </h3>
                  </div>
                  <FormGroup check disabled>
                    <Label check>
                      <Input defaultChecked defaultValue="" disabled type="checkbox" />
                            FullScreen <span className="form-check-sign" />
                    </Label>
                  </FormGroup>
                  <FormGroup check disabled>
                    <Label check>
                      <Input defaultChecked defaultValue="" disabled type="checkbox" />
                            100% stable <span className="form-check-sign" />
                    </Label>
                  </FormGroup>
                  <FormGroup check disabled>
                    <Label check>
                      <Input defaultChecked defaultValue="" disabled type="checkbox" />
                            1 vs 2 <span className="form-check-sign" />
                    </Label>
                  </FormGroup>
                  <FormGroup check disabled>
                    <Label check>
                      <Input defaultChecked defaultValue="" disabled type="checkbox" />
                            2 vs 2 <span className="form-check-sign" />
                    </Label>
                  </FormGroup>
                  <br />
                </Col>
                <Col sm="12" md="2" />
              </Row>
              <p className="text-success">
                The game will run in high quality without any problems.
              </p>
            </TabPane>
          </TabContent>
        </Container>
      </div>{" "}
    </>
  );
}

export default SectionProgress;
